// extracted by mini-css-extract-plugin
export var formContainer = "_g8-0";
export var message = "_g8-1";